export default __webpack_public_path__ + "static/media/B172.2974a207.png";